import { useEffect, useState } from "react";
import { Tag, Gift, Clock } from "lucide-react";
import api from "../lib/apiClient";

function useCountdown() {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  // Counts down to the next midnight in Pacific Time (PST/PDT) and resets daily.
  const la = new Date(new Date(now).toLocaleString("en-US", { timeZone: "America/Los_Angeles" }));
  const secsIntoDay = la.getHours() * 3600 + la.getMinutes() * 60 + la.getSeconds();
  let diff = Math.max(0, 86400 - secsIntoDay);
  const h = Math.floor(diff / 3600); diff -= h * 3600;
  const m = Math.floor(diff / 60); const s = diff - m * 60;
  const pad = (x) => String(x).padStart(2, "0");
  return `${pad(h)}:${pad(m)}:${pad(s)}`;
}

export default function PromoBar() {
  const time = useCountdown();
  const [bogo, setBogo] = useState(false);
  const [saleOn, setSaleOn] = useState(false);
  useEffect(() => {
    api.get("/promo/bogo").then((r) => setBogo(!!r.data?.enabled)).catch(() => {});
    api.get("/promo/sitewide").then((r) => setSaleOn(!!r.data?.enabled)).catch(() => {});
  }, []);
  if (!bogo && !saleOn) return null;
  return (
    <div className="bg-white/70 backdrop-blur border-b border-[#efe6d2]" data-testid="promo-bar">
      <div className="flex items-center justify-center gap-3 py-2.5 px-4 text-center">
        <span className="flex items-center gap-2 font-display font-bold text-sm sm:text-base" data-testid="promo-bar-headline">
          {bogo ? (
            <><Gift className="w-4 h-4" /> BUY 1 GET 1 FREE — SITEWIDE</>
          ) : (
            <><Tag className="w-4 h-4" /> 40% OFF SITEWIDE</>
          )}
        </span>
        <span className="flex items-center gap-1.5 text-xs sm:text-sm font-semibold pill bg-[#1a1815] text-white px-3 py-1" style={{ fontVariantNumeric: "tabular-nums" }}>
          <Clock className="w-3.5 h-3.5" style={{ color: "var(--gold)" }} />
          <span style={{ color: "var(--gold)" }}>Ends in {time}</span>
        </span>
      </div>
    </div>
  );
}
